import { FormDataGroup } from 'src/types';

export const partialDataCitaConfigurador: Partial<FormDataGroup> = {
  headers: { DESC_FORMOBJECTIVE: 'Cita' },
  fields: {
    formFields: { M_OBSERVATION_BRAND: 'Petición para reservar una cita en el concesionario.' },
    formularioFlag: 'prospect',
    formName: 'lead-cita-configure',
    formType: 'contact',
    pageCategory: 'Cita',
  },
};
